import type { CenterProps } from '@hover/blueprint';
import { Center, Heading, Icon, VStack } from '@hover/blueprint';
import { iPlus } from '@hover/icons';
import type { Project as ProjectType } from 'mock/generated/types';
import React, { useEffect } from 'react';

import {
  addUploadToProject,
  closeUploadSheetAfterUpload,
  uploadToProjectWithoutSelection,
} from 'src/modules/homeownerApp/components/UploadImage';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { useCurrentProject } from '../Menu/EditProject';

interface EmptyStateProps extends CenterProps {
  text?: string;
}

export const EmptyState = ({ text, ...props }: EmptyStateProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const ctaText = text ?? t('projects.emptyState');
  const { setCurrentMenu } = useHomeownerAppContext();

  const { project } = useCurrentProject();

  let projectToUpload = project as ProjectType;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (project?.id) projectToUpload = project as ProjectType;
  }, [project?.id]);

  const handleClick = () => {
    if (projectToUpload) {
      closeUploadSheetAfterUpload(true);
      uploadToProjectWithoutSelection(true);
      addUploadToProject(projectToUpload);
    }
    setCurrentMenu(HomeownerAppMenuNames.UPLOAD_PHOTO);
  };

  return (
    <Center
      alignSelf="flex-start"
      borderColor="interactive.glass"
      borderRadius="large"
      borderStyle="solid"
      borderWidth="1px"
      cursor="pointer"
      height={{ base: '245px', tablet: '456px' }}
      onClick={handleClick}
      sx={{ aspectRatio: { base: 1, desktop: 3 / 4 } }}
      {...props}
      boxSizing="border-box"
    >
      <VStack width={600}>
        <Icon color="neutral.0" icon={iPlus} m={0} />
        <Heading
          color="neutral.0"
          mt="200 !important"
          textAlign="center"
          textStyle="headingXs"
        >
          {ctaText}
        </Heading>
      </VStack>
    </Center>
  );
};
